import { useState, useEffect } from 'react';
import { Trans, useTranslation } from "react-i18next";
import {
    Circle,
    FeatureGroup,
    LayerGroup,
    LayersControl,
    MapContainer,
    Marker,
    Popup,
    Rectangle,
    TileLayer, useMapEvent
} from "react-leaflet";


const center = [46.38, 11.29];
const rectangle = [
    [51.49, -0.08],
    [51.5, -0.06],
];



export default function Map ({setter}) {

    const { t } = useTranslation();
    const [position, setPosition] = useState([46.3832, 11.288])

function MyComponent() {
    const map = useMapEvent('click', (c) => {
        //map.setView(position,  map.getZoom()) //
        //console.log([c.latlng.lat, c.latlng.lng])
        setPosition ([c.latlng.lat, c.latlng.lng])
        setter ([c.latlng.lat, c.latlng.lng])
    })
    return null
}

    return (
        <>
            <MapContainer center={center} zoom={8} scrollWheelZoom={true}>
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={position} eventHandlers={{
                    click: () => {
                        console.log('marker clicked')
                    },
                }}>
                    <Popup>
                        {position}
                    </Popup>
                </Marker>

                <MyComponent />
            </MapContainer>
        </>
    )
}